import { TBColumn } from '../../interfaces/TableBits.interfaces';
const columns: TBColumn[] = [
    {
        id: "bussinesName",
        label: 'Nombre',
        align: 'left',
    },
    {
        id: "campus",
        label: 'Sede',
        align: 'left',
    },
    {
        id: "project",
        label: 'Proyecto',
        align: 'left',
    },
    {
        id: "client",
        label: 'Áreas o proyectos',
        align: 'left',
    },
    {
        id: "dateOfAdmission",
        label: 'Fecha de ingreso',
        align: 'left',
    },
    {
        id: "Puesto",
        label: 'Puesto',
        align: 'left',
    },
    {
        id: "grossSalary",
        label: 'Sueldo',
        align: 'left',
    },
];

export default columns;